import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import * as Yup from "yup";

import { BasicForm } from "@components/shared";
import timezones from "@lib/timezones";

export default function ContestPickupForm({
  contactName = "",
  contactNumber = "",
  contactEmail = "",
  id,
  onSuccess,
  pickupDate = "",
  pickupTime = "",
  pickupTimezone = "",
}) {
  const [loading, setLoading] = useState(false);

  function onSubmit(formData) {
    setLoading(true);

    const formatted = {
      ...formData,
    };

    return onUpdate(formatted);
  }

  function onUpdate(formData) {
    const req = { ...formData };

    axios
      .put(`/contests/${id}/contest-pickup/`, req)
      .then(() => {
        toast.success("Contest Updated!");
        setLoading(false);
        onSuccess();
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  const fields = [
    {
      name: "contact_name",
      label: "Contact for Prize Pickup Name",
      initialValue: contactName,
      required: true,
      schema: () => Yup.string().max(100, "Too long!").required("Required"),
    },
    {
      name: "contact_number",
      label: "Contact for Prize Pickup Number",
      mask: {
        pattern: "(999) 999-9999",
        placeholder: "(XXX) XXX-XXXX",
      },
      initialValue: contactNumber,
      required: true,
      schema: () => Yup.string().max(50, "Too long!").required("Required"),
    },
    {
      name: "contact_email",
      label: "Contact for Prize Pickup Email",
      initialValue: contactEmail,
      required: true,
      schema: () =>
        Yup.string()
          .max(50, "Too long!")
          .email("Not a valid email")
          .required("Required"),
    },
    {
      name: "pickup_date",
      initialValue: pickupDate,
      label: "Pickup Date",
      required: true,
      schema: () => Yup.string().required("Required"),
      datepicker: {},
    },
    {
      name: "pickup_time",
      initialValue: pickupTime,
      required: true,
      schema: () => Yup.string("Required").nullable().required("Required"),
      label: `Pickup Time`,
      timepicker: {},
    },
    {
      name: "pickup_timezone",
      initialValue: pickupTimezone,
      required: true,
      select: true,
      schema: () => Yup.string("Required").nullable().required("Required"),
      label: "Pickup Timezone",
      options: timezones,
    },
  ];

  return (
    <BasicForm
      fields={fields}
      loading={loading}
      onSubmit={(d) => onSubmit(d)}
      buttonProps={{
        fullWidth: false,
      }}
    />
  );
}
